<div class="login-container">
	<div class="background">
		<div class="shape"></div>
		<div class="shape"></div>
	</div>
	<div class="login-form">
		<img style="width: 200px;margin-left: 18%;" src="../assets/img/3Cube-White.png" alt="3Cube Logo" />
		@if (step == 1) {
		<form [formGroup]="moduleForm" (ngSubmit)="login()">
			<label for="username" class="control-label">Username</label>
			<input type="text" placeholder="Username" id="username" formControlName="username">
			<p *ngIf="showError('username')" class="error">
				<span *ngIf="f.username.errors?.required">
					Required
				</span>
			</p>
			<label for="password" class="control-label">Password</label>
			<input type="password" placeholder="Password" id="password" formControlName="password">
			<p *ngIf="showError('password')" class="error">
				<span *ngIf="f.password.errors?.required">
					Required
				</span>
			</p>
			<p *ngIf="displayError" class="error text-center mt-2">
				<span>{{errorMsg}}</span>
			</p>
			<button type="submit" [disabled]="showLoader">
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin" class="text-dark"></fa-icon>
				Log In
			</button>
		</form>
		}@else if (step == 2) {
		<div class="row px-3">
			@if (qrStep == 1) {
			<div class="col">
				<div class="row">
					<div class="col-9">
						<h3>Set Up Google Authenticator App</h3>
						<h4>
							<div class="my-circle">1</div>
							Download an App
						</h4>
						<p class="px-3">
							Download the Google Authenticator App from&nbsp;
							<a href="https://play.google.com" target="_blank">
								Google Play Store
							</a>
							&nbsp;or&nbsp;
							<a href="https://apps.apple.com" target="_blank">App Store.</a>
						</p>
					</div>
					<div class="col text-center">
						<div class="app-icon-container">
							<a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US"
								target="_blank" class="mt-4">
								<img src="../assets/img/get_it_on_google_play.png" class="w-75 h-auto" />
							</a>
							<a href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank">
								<img src="../assets/img/download_on_app_store.png" class="mt-2 w-75  h-auto" />
							</a>
						</div>
						<button type="button" class="btn btn-success my-2 w-100" (click)="next()">
							I Have An App
						</button>
					</div>
				</div>
			</div>
			}@else if (qrStep == 2) {
			<div class="col">
				<form role="form" (ngSubmit)="verifyOTP()">
					@if (showQR) {
					<div class="row">
						<div class="col-9">
							<h3>Set Up Google Authenticator App</h3>
							<h4>
								<div class="my-circle">2</div>Add Your Account
							</h4>
							<p class="ps-30">
								Scan the QR code to get the code you will need to complete the
								verification
								in
								step 3 and to verify future logins.
							</p>
							<h4>
								<div class="my-circle">3</div>Verify Your Account
							</h4>
							<p class="ps-30">
								Enter the 6 digit code provided from your authenticator app.
							</p>
						</div>
						<div class="col text-center">
							<img src="{{qrToShow}}" alt="QR Code" class="w-100 h-auto" />
						</div>
					</div>
					}
					<div class="row my-2">
						<div class="col">
							<label for="username" class="control-label text-center">
								Enter the 6 digit code provided from your authenticator app.
							</label>
							<input type="text" placeholder="Enter Code" [(ngModel)]="auth.otp"
								[ngModelOptions]="{standalone: true}">
							<p *ngIf="displayError" class="error text-center mt-2">
								<span>{{errorMsg}}</span>
							</p>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<button type="submit" [disabled]="showLoader">
								<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"
									class="text-dark"></fa-icon>
								Verify
							</button>
						</div>
					</div>
				</form>
			</div>
			}
		</div>
		}
		<div class="terms-section">
			By logging in, you agree to our
			<span class="clickable-text" (click)="gotoTermsAndCondition()">
				<br>Terms & Conditions
			</span>
		</div>
	</div>
</div>